export const enrollmentStates = [
  {
    id: 'enrolled',
    chip: 'Enrolled',
    tone: 'green',
    dateLabel: 'Enrollment Date',
    dateValue: 'Dec 10, 2018 - 5:00 AM',
  },
  {
    id: 'in-progress',
    chip: 'In Progress',
    tone: 'blue',
    dateLabel: 'Enrollment Date',
    dateValue: 'Jan 02, 2026 - 9:12 AM',
  },
  {
    id: 'cooling',
    chip: 'Cooling',
    tone: 'amber',
    dateLabel: 'Cancel Date',
    dateValue: 'Jan 28, 2026 - 3:18 PM',
  },
  {
    id: 'action-required',
    chip: 'Action Required',
    tone: 'amber',
    dateLabel: 'Action Required Date',
    dateValue: 'Jan 16, 2026 - 8:02 AM',
  },
  {
    id: 'pending-opt-out',
    chip: 'Pending Opt Out',
    tone: 'amber',
    dateLabel: 'Opt Out Date',
    dateValue: 'Jan 21, 2026 - 9:40 AM',
  },
  {
    id: 'opted-out',
    chip: 'Opted Out',
    tone: 'red',
    dateLabel: 'Opt Out Date',
    dateValue: 'Jan 22, 2026 - 2:31 PM',
  },
  {
    id: 'cancelled',
    chip: 'Cancelled',
    tone: 'red',
    dateLabel: 'Cancel Date',
    dateValue: 'Jan 25, 2026 - 5:10 PM',
  },
  {
    id: 'terminated',
    chip: 'Terminated',
    tone: 'red',
    dateLabel: 'Termination Date',
    dateValue: 'Jan 30, 2026 - 6:00 PM',
  },
];

export const statusCards = [
  { label: 'Product Selection Status', value: 'Incomplete', tone: 'amber', type: 'pill' },
  { label: 'Has Live Selections', value: 'Yes', tone: 'green', type: 'pill' },
  { label: 'Program Consent Status', value: 'Granted', tone: 'blue', type: 'pill' },
  { label: 'Data Consent Status', value: 'Pending', tone: 'amber', type: 'pill' },
  { label: 'Last Update', value: 'Jan 20, 2026 - 6:14 PM', tone: 'slate', type: 'text' },
];

export const mockSummary = [
  { label: 'Program', value: 'GMX Enrollment' },
  { label: 'BAC', value: '302-884-191' },
  { label: 'Region', value: 'Southwest - AZ' },
  { label: 'Owner', value: 'Morgan Reed' },
  { label: 'Dealer Group', value: 'Autumn Ridge Auto' },
  { label: 'Current Phase', value: 'Selection Review' },
];

export const mockTimeline = [
  { label: 'Enrollment opened', value: 'Dec 10, 2018 - 5:00 AM' },
  { label: 'Program consent signed', value: 'Dec 12, 2018 - 4:21 PM' },
  { label: 'Selection upload received', value: 'Jan 08, 2026 - 11:07 AM' },
  { label: 'Latest dealer touch', value: 'Jan 19, 2026 - 2:44 PM' },
];
